import { useSearchParams } from 'react-router-dom';
import { AppBar } from '../components/AppBar';
import { ChallanList } from '../components/ChallanList';
import { PayNowBar } from '../components/PayNowBar';
import { AssistantFAB } from '../components/AssistantFAB';
import { ChatSheet } from '../components/ChatSheet';
import { challans, selectedVehicle } from '../data/challans';
import styles from './ChallanLandingScreen.module.css';

export function ChallanLandingScreen() {
  const [searchParams, setSearchParams] = useSearchParams();
  const isChatOpen = searchParams.get('chat') === 'open';
  const hasUnpaid = challans.some((c) => c.status === 'Unpaid');

  const toggleChat = () => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (next.get('chat') === 'open') {
        next.delete('chat');
      } else {
        next.set('chat', 'open');
      }
      return next;
    });
  };

  return (
    <div className={styles.screen}>
      <AppBar vehicle={selectedVehicle} />
      <ChallanList challans={challans} />
      {hasUnpaid && <PayNowBar challans={challans} />}
      <AssistantFAB onClick={toggleChat} isOpen={isChatOpen} hasPayNow={hasUnpaid} />
      <ChatSheet isOpen={isChatOpen} onClose={toggleChat} />
    </div>
  );
}
